export const historyActionTypes = {
  clearInput: '[History message] - clear input field',
  loadMore: '[History message] - load one more page',
  editHistory: '[History message] - edit history message',
  deleteHistory: '[History message] - delete history message',
  saveEditedHistory: '[History message] - save edited message',
  saveNewHistory: '[History message] - save new message',
};
